/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         compositionType: "EMBED",
 *         credentialIds: ["credential_ids"],
 *         keyId: "key_id"
 *     }
 */
export interface PresentationIssueRequest {
    compositionType: Truvity.PresentationIssueRequestCompositionType;
    credentialIds: string[];
    /** All supported DID methods. Default is "web". */
    didMethod?: Truvity.PresentationIssueRequestDidMethod;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    holder?: string;
    /** The ID of the key to sign the credential. */
    keyId: string;
}
